import React, { useEffect, useRef, useState } from 'react';
import "./IncidentM.css"

const IncidentM = () => {
  const canvasRef = useRef(null);
  const [selectedBarIndex, setSelectedBarIndex] = useState(null);

  function roundRect(ctx, x, y, width, height, borderRadius) {
    ctx.beginPath();
    ctx.moveTo(x + borderRadius, y);
    ctx.lineTo(x + width - borderRadius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + borderRadius);
    ctx.lineTo(x + width, y + height - borderRadius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - borderRadius, y + height);
    ctx.lineTo(x + borderRadius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - borderRadius);
    ctx.lineTo(x, y + borderRadius);
    ctx.quadraticCurveTo(x, y, x + borderRadius, y);
    ctx.closePath();
  }

  const data = [
    { value: 91, color: '#29A343', title: 'Cleared' },
    { value: 53, color: '#E12C33', title: 'Not Cleared' },
  ];

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const options = {
      chartArea: { left: 0, top: 0, right: 0, bottom: 0 },
      width: 180,
      height: 160,
      barPadding: 25,
      barColor: '#F8FBFF',
    };

    const chartWidth = options.width - options.chartArea.left - options.chartArea.right;
    const chartHeight = options.height - options.chartArea.top - options.chartArea.bottom;
    const maxValue = Math.max(...data.map((item) => item.value));
    const barWidth = chartWidth / maxValue;

    ctx.clearRect(0, 0, options.width, options.height);

    data.forEach((item, index) => {
      const barX = options.chartArea.left;
      const barY = options.chartArea.top + index * (options.barPadding + chartHeight / data.length);
      const barHeight = chartHeight / data.length - options.barPadding;

      ctx.fillStyle = item.color;
      roundRect(ctx, barX, barY, item.value * barWidth, barHeight, 10);
      ctx.fill();
    });

    const handleClick = (event) => {
      const rect = canvas.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      let clickedBarIndex = null;

      data.forEach((item, index) => {
        const barX = options.chartArea.left;
        const barY = options.chartArea.top + index * (options.barPadding + chartHeight / data.length);
        const barHeight = chartHeight / data.length - options.barPadding;

        if (x >= barX && x <= barX + item.value * barWidth && y >= barY && y <= barY + barHeight) {
          clickedBarIndex = index;
        }
      });

      setSelectedBarIndex(clickedBarIndex);
    };

    canvas.addEventListener('click', handleClick);

    return () => {
      canvas.removeEventListener('click', handleClick);
    };

  }, [data]);

  return (
    <div className="card_inciM">
      <h4 className="exp_iniM">Incident Management</h4>
      <div>
        <canvas className="chart_In" ref={canvasRef} width="180" height="160"></canvas>
        {selectedBarIndex !== null && (
          <div className="popup" style={{ top: selectedBarIndex * 80 + 40 }}>
            <div className="popup-title">
              <h3>{data[selectedBarIndex].title}</h3>
            </div>
          </div>
        )}
        <div className="cleared">Cleared</div>
      <div className="clearedN">Not Cleared</div>
      <div className="three">36</div>
      <div className="three_1">18</div>
      </div>
    </div>
  );
};

export default IncidentM;
